<template>
    <div class="d-flex align-items-center">
        <div class="mr-2 d-none d-xl-inline-block">
            <slot name="icon" />
        </div>
        <div class="w-100 mr-2">
            <slot name="progress-bar" />
        </div>
        <slot name="dropdown" />
    </div>
</template>

<script>
export default {
    name: 'ProgressContainer',
}
</script>
